export default {
    /* 
    * 度分秒转度
     */
    change2D(val) {
        return (
            Math.abs(val.degree) +
            (Math.abs(val.minute) / 60 + Math.abs(val.second) / 3600)
        );
    },
    /*
    * 度转度分秒
    */
    change2Dms(val) {
        let value = Math.abs(val);
        let temp = {};
        temp.degree = Math.floor(value); // 度
        temp.minute = Math.floor((value - temp.degree) * 60); // 分
        temp.second = Math.floor(((value - temp.degree) * 3600) % 60); // 秒
        return temp;
    }
}


// WEBPACK FOOTER //
// ./src/data/utils.js